<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary" @click="$router.push('/products/create')">
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
      <table-filter :value="customTableFilter" @input="searchProduct" placeholder="Nach Name oder Barcode suchen..." />
      <div class="row">
        <div class="col-sm-6" v-if="productCategories.length > 0">
            <label>Product Kategorie</label>
          <div class="form-group has-label">
            <multiselect v-model="selectedProductCategories" :multiple="true" :options="productCategories" track-by="id"
              label="name" @input="filterData" />
          </div>
        </div>
        <div class="col-sm-6 text-right">
          <label>&nbsp;</label>
          <div class="form-group has-label">
            <a :href="downloadUrl" class="btn btn-fill btn-info">
              <i class="fa fa-download"></i>
              Download
            </a>
          </div>
        </div>
      </div>
      <transition name="el-fade-in-linear">
        <div style="overflow-x: auto; margin-top: 0.75em;">
          <products-table v-if="!loading" :products="products" :sortable="sortable" :show-warehouses="showWarehouses"
            :product-categories="productCategories" @updateProduct="updateProduct" @deleteProduct="deleteProduct"
            @filterProductCategory="filterProductCategory" @sortBy="sortBy" />
        </div>
      </transition>
      <l-pagination background layout="prev, pager, next" :per-page="10" :page-count="pageCount" :value="currentPage"
        @input="changePage" @changePerPage="changePerPage" />
    </card>
  </div>
</template>

<script>
import ProductsTable from './products-table'
import productsIndexMethods from './products-index-methods'
import hasPagination from 'src/has-pagination'
import debounce from 'lodash/debounce'
import api from 'src/api'

export default {
  components: { ProductsTable },
  mixins: [productsIndexMethods, hasPagination],
  data() {
    return {
      api,
      productCategories: [],
      selectedProductCategories: [],
      loading: true,
      customTableFilter: '',
      showWarehouses: false,
      sortable: {
        columns: [
          {
            name: 'Name',
            key: 'products.name',
            sortable: true
          },
          {
            name: 'Kategorie',
            key: 'product_categories.name',
            sortable: true
          },
          {
            name: 'Hersteller',
            key: 'products.hersteller',
            sortable: true
          },
          {
            name: 'Lieferant',
            key: 'suppliers.name',
            sortable: false
          },
          {
            name: 'Einheit',
            key: 'units.name',
            sortable: true
          },
          {
            name: 'EK netto',
            key: 'einkaufspreis',
            sortable: true
          },
          {
            name: 'VK Brutto',
            key: 'products.price',
            sortable: true
          },
          {
            name: 'Auf Lager',
            key: 'quantity',
            sortable: true
          },
          {
            name: 'Lagerwert',
            key: 'Lagerwert',
            sortable: true
          },
          {
            name: 'Verkauft 12M',
            key: 'quantity_sold',
            sortable: true,
            tooltip: 'Verkauft in den letzten 12 Monaten'
          },
          {
            name: 'Letzter Eingang',
            key: 'latest_in',
            sortable: true
          },
          {
            name: 'Letzter Ausgang',
            key: 'latest_out',
            sortable: true
          },
          {
            name: 'Exp',
            key: 'next_expiry_date',
            sortable: true,
            tooltip: 'Nächster Ablaufdatumstermin'
          },
          {
            name: 'Lager',
            sortable: false
          },
          {
            name: 'Bild',
            sortable: false
          },
          {
            name: '',
            sortable: false
          }
        ],
        sortColumn: 'products.name',
        sortOrders: {
          'products.name': 1,
          'product_categories.name': 1,
          'products.hersteller': 1,
          'suppliers.name': 1,
          'units.name': 1,
          'einkaufspreis': 1,
          'products.price': 1,
          'quantity': 1,
          'lager_soll_menge': 1,
          'quantity_sold': 1,
          'latest_in': 1,
          'latest_out': 1,
          'next_expiry_date': 1
        }
      }
    }
  },
  methods: {
    filterData() {
      this.loading = true
      this.changePage(1)
    },
    getCustomQueryData() {
      return {
        custom_search: encodeURIComponent(this.customTableFilter),
        product_categories: this.selectedProductCategories.length ? encodeURIComponent(this.selectedProductCategories.map(pc => pc.id)) : '',
        'sort-by-column': this.sortable.sortColumn,
        'sort-by-order': this.sortable.sortOrders[this.sortable.sortColumn] > 0 ? 'ASC' : 'DESC'
      }
    },
   async searchProduct(search) {
      this.customTableFilter = search
      let isGS1 = false;
      const gs1Patterns = ['01', '10', '17', '18', '21'];

      for (let pattern of gs1Patterns) {
        if (this.customTableFilter.includes(pattern)) {
          isGS1 = true;
          break;
        }
      }
      if (isGS1) {
        try {
          const { data } = await this.$http.get(`/product/decode/${this.customTableFilter}`);
          this.identifiers = data.identifiers;
        } catch (error) {
          console.error("Error fetching identifiers:", error);
          throw error;
        }


        Object.entries(this.identifiers).forEach(([key, item]) => {
          // GTIN
          if (key === "01") {
              this.customTableFilter = item.content
          }
        });
      }
      isGS1 = false;
      if (search.length === 0 || search.length > 2) {
        this.bla()
      }



    },
    bla: debounce(function () {
      this.changePage(1)
    }, 500),
    getData(query) {
      return this.$http.get(`/products?${query}`).then(({ data }) => {
        this.products = data.data
        this.pageCount = data.last_page
        this.loading = false
      })
    },
    filterProductCategory(category) {
      this.selectedProductCategories.push(category)
      this.filterData()
    },
    updateProduct(product) {
      product.product_category_id = product.product_category ? product.product_category.id : null
      product.unit_id = product.unit ? product.unit.id : null
      this.$http.put(`/products/${product.id}`, product).then(({ data }) => {
        const index = this.products.findIndex(p => p.id === product.id)
        this.products.splice(index, 1, product)
      })
    },
    // @override
    changePage(page) {
      if (this.currentPage !== page) {
        this.$router.push(`/products?page=${page}`)
      } else {
        this.fetchTableData()
      }
    },
    sortBy(column) {
      this.currentPage = 1
      this.loading = true
      this.sortable.sortColumn = column
      this.sortable.sortOrders[column] = this.sortable.sortOrders[column] * -1
      this.fetchTableData()
    }
  },
  computed: {
    downloadUrl() {
      return `${api}/products/download?${this.getQuery()}`
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query && to.query.page) {
      this.currentPage = +to.query.page
      this.fetchTableData().then(() => { next() })
    } else {
      this.currentPage = 1
      this.fetchTableData().then(() => { next() })
    }
  },
  created() {
    if (this.$route.query && this.$route.query.page) {
      this.currentPage = +this.$route.query.page
    }

    this.fetchTableData()
    this.$http.get('/product_categories').then(({ data }) => { this.productCategories = data })
    this.$http.get(`/warehouses`).then(({ data }) => { this.showWarehouses = data.length > 1 })
  }
}
</script>
